import { UseFormRegister } from "react-hook-form";
import useShop from "../../hooks/useShop.hook";
import { ProductFormData } from "../../types/product";
import { LexicalTextEditor } from "../richtext/richTextEditor.comp";
import localeCore from "../../core/locale.core";
import { useTranslation } from "../../core/translation.core";
import { EditingMode } from "../reuseables/form.comp";

export default function ProductDescriptionEditor({
  register,
  fieldName,
  productId,
}: {
  register: UseFormRegister<any>;
  fieldName: string;
  productId?: string;
}) {
  const { selectedShop } = useShop();
  const { t, msg } = useTranslation();

  if (!selectedShop) return null;

  return (
    <div className="space-y-2">
      <div className="grid gap-4 2xl:grid-flow-col 2xl:auto-cols-fr">
        {selectedShop.locales.map((locale) => {
          const fullFieldName = `${fieldName}.${locale.replace("-", "")}` as keyof ProductFormData;
          return (
            <div key={locale}>
              <label className="text-xs">{localeCore.getLocaleLabel(locale, t, msg) ?? locale}</label>
              <LexicalTextEditor id={productId} locale={locale} fieldName={fullFieldName} register={register} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
